module.exports = __webpack_public_path__ + "img/Watchlist.0de42313.svg";